import React, {Component} from 'react';
import {Formik} from 'formik';
import {APP_LOADED} from "../../constants/postMessages";
import './index.scss';

/**
 * TestUI
 */
export class TestUI extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    frameUrl: 'http://localhost:3000/auth',
  }
  handlePostValues = (values) => {
    const data = JSON.stringify(values);
    this.ifr.contentWindow.postMessage(data, "*");
  }
  handleLoad = (e) => {
    if (e.data === APP_LOADED) {
      console.log('Document Loaded');
    }
  }

  componentDidMount() {
    window.addEventListener("message", this.handleLoad);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.handleLoad);
  }

  render() {
    return (
        <div className="testkit-container">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xs-12 col-sm-3">
                <Formik
                    initialValues={{
                      authToken: 'jPBWmzLCDINBTJvPwT39VqfV9s0TpVIgYvDICgWjzJE8M3EwAG1hRhIawOZpKdRGFtdG8V+B5xnITarjt6/Vf5AKcR8TULJmfXgk9mDa+/B61WTVW78FmdZn/xC6/xuyj5gB9+S4BLF5yW50QJH04T1KhDbjeIfN9evSbu80FpeqXyOxHp3LL1YWx5t53MNe',
                      enterpriseId: 'jsjek9k',
                      applianceUuid: '51d02da2-a6e2-4f56-b4da-4d2239566b66',
                    }}
                    validate={values => {
                      // same as above, but feel free to move this into a class method now.
                      let errors = {};
                      // if (!values.email) {
                      //   errors.email = 'Required';
                      // } else if (
                      //   !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
                      // ) {
                      //   errors.email = 'Invalid email address';
                      // }
                      return errors;
                    }}
                    onSubmit={(
                        values,
                        {setSubmitting, setErrors /* setValues and other goodies */}
                    ) => {
                      this.handlePostValues(values);
                      setSubmitting(false);
                    }}
                    render={({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                    }) => (
                        <form className="form" onSubmit={handleSubmit}>
                          <div className="testkit-title">IDP Admin Client
                            Testing
                          </div>
                          <div className="form-group">
                            <label>Auth Token</label>
                            <textarea
                                type="text"
                                name="authToken"
                                className="form-control"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                defaultValue={values.authToken}
                            />
                            {
                              touched.authToken &&
                              errors.authToken &&
                              (
                                  <span className="help-block">
                            {errors.authToken}
                          </span>
                              )
                            }
                          </div>
                          <div className="form-group">
                            <label>Enterprise ID</label>
                            <input
                                type="text"
                                name="enterpriseId"
                                className="form-control"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.enterpriseId}
                            />
                            {
                              touched.enterpriseId &&
                              errors.enterpriseId &&
                              (
                                  <span className="help-block">
                            {errors.enterpriseId}
                          </span>
                              )
                            }
                          </div>
                          <div className="form-group">
                            <label>Appliance UUID</label>
                            <input
                                type="text"
                                name="applianceUuid"
                                className="form-control"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.applianceUuid}
                            />
                            {
                              touched.applianceUuid &&
                              errors.applianceUuid &&
                              (
                                  <span className="help-block">
                            {errors.applianceUuid}
                          </span>
                              )
                            }
                          </div>
                          <div className="form-group">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            >
                              Post Values to Frame
                            </button>
                          </div>
                        </form>
                    )}
                />

              </div>
              <div className="col-xs-12 col-sm-9">
                <div className="frame-title">
                  Cloud Preview Frame
                </div>
                <iframe className="preview"
                        title="testPreview"
                        frameBorder="0"
                        src={this.state.frameUrl}
                        ref={(f) => this.ifr = f}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default TestUI;



// WEBPACK FOOTER //
// ./src/components/TestUI/index.js